import { bind } from 'bind-decorator';
import React from 'react';
import { colours } from '../../../../../../styles/colours';
import Picker from '../../../../../general/date/date-picker';

interface IProps {
  errored: boolean;
  warning: boolean;
  value?: null | string;

  onChange: (value: string) => void;
}

class DatePicker extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps): boolean {
    const { props } = this;

    if (props.errored !== nextProps.errored) {
      return true;
    }

    if (props.warning !== nextProps.warning) {
      return true;
    }

    if (props.value !== nextProps.value) {
      return true;
    }

    return false;
  }

  render() {
    const { errored, value, warning } = this.props;
    const style = {}; // {background:'#DDEAF6', borderColor:'#B6D3EC'}
    const labelStyle = { fontWeight: 'normal' }; // {color:'#1E4E79', fontWeight:'bold'}

    style.textTransform = 'capitalize';
    style.minWidth = '100px';

    if (errored) {
      style.background = colours.red200;
      style.background = colours.red400;
      style.color = `${colours.red} !important`;
    } else if (warning && value == null) {
      style.background = colours.orange100;
      style.borderColor = colours.orange300;
      style.color = `${colours.orange300} !important`;
    }

    return (
      <Picker
        {...this.props}
        style={style}
        label="Select Date"
        labelStyle={labelStyle}
        value={value}
        onChange={this.onChange}
      />
    );
  }

  @bind
  private onChange(dateTime: string) {
    this.props.onChange(dateTime);
  }
}

export default DatePicker;
